import { ElementRef, InjectionToken } from '@angular/core';

export const ASSETS_BASE_PATH = new InjectionToken<string>('ASSETS_BASE_PATH');

export const applyAssetsPatch = (
  assetsBaseUrl: string | null | undefined,
  elementRef: ElementRef,
  variables: string[],
): void => {
  if (assetsBaseUrl == null) {
    return;
  }

  // Przesunięcie na koniec event loopa, aby wykonało się po wstawieniu elementu do DOM
  setTimeout(() => {
    variables.forEach((flagVar) => {
      const currVar = window.getComputedStyle(elementRef.nativeElement).getPropertyValue(flagVar);
      const newVar = currVar.replace(/\.\//g, assetsBaseUrl + '/');

      elementRef.nativeElement.style.setProperty(flagVar, newVar);
    });
  }, 0);
};
